export interface NoticePart {
  text: string;
  href?: string;
}

const LINK = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g;

export function noticeParts(raw: string): NoticePart[] {
  const source = raw || "";
  const parts: NoticePart[] = [];
  let last = 0;
  for (const match of source.matchAll(LINK)) {
    const index = match.index ?? 0;
    if (index > last) parts.push({ text: source.slice(last, index) });
    parts.push({ text: match[1], href: match[2] });
    last = index + match[0].length;
  }
  if (last < source.length) parts.push({ text: source.slice(last) });
  return parts.filter((part) => part.text.length > 0);
}
